import {Component, ContentChild} from '@angular/core';
import {AbstractModal} from './abstract-modal';
import {ModalDialogComponent} from './modal-dialog/modal-dialog.component';

@Component({
    selector: 'vui-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent extends AbstractModal {
    @ContentChild(ModalDialogComponent, {static: false}) public modalDialog: ModalDialogComponent;
}
